import React from 'react';
import {connect} from 'react-redux';

import {T} from 'Actions/translate';
class ProxyDeliveryReceivePackageCard extends React.Component {
    state = {
        previewReceiveImageDialogOpened: false,
    };

    render() {
        const {f1PackageReceive} = this.props;
        return (
            <ul className="package-receive-container parent-package-ul">
                {JSON.stringify(f1PackageReceive) !== '{}' &&
                f1PackageReceive.products &&
                f1PackageReceive.products.length > 0
                    ? f1PackageReceive.products.map(
                          (packageReceiveItem, packageReceiveIndex) => (
                              <li
                                  className="parent-receive-li external-li"
                                  key={packageReceiveIndex}>
                                  <div className="parent-sku">
                                      <div className="parent-first-column">
                                          <div className="parent-sku-value">
                                              {packageReceiveItem.sku}
                                          </div>
                                      </div>
                                  </div>
                                  <div className="package-second-row">
                                      <div className="parent-first-column">
                                          {T('host_product_specifications')}
                                          <span className="specifications">
                                              {
                                                  packageReceiveItem.specifications
                                              }
                                          </span>
                                      </div>
                                      <div className="parent-second-column">
                                          {T('proxy_delivery_order_quantity')}
                                          <span className="parent-first-column-value">
                                              {packageReceiveItem.quantity}
                                          </span>
                                      </div>
                                  </div>

                                  <ul className="sub-package-receive-container sub-package-ul">
                                      {packageReceiveItem.childProducts &&
                                      packageReceiveItem.childProducts.length >
                                          0
                                          ? packageReceiveItem.childProducts.map(
                                                (
                                                    childProductsItem,
                                                    childProductsIndex,
                                                ) => (
                                                    <li
                                                        className="sub-receive-li"
                                                        key={
                                                            childProductsIndex
                                                        }>
                                                        <div className="sub-sku">
                                                            {
                                                                childProductsItem.sku
                                                            }
                                                        </div>
                                                        <div className="package-first-row">
                                                            <div className="parent-first-column">
                                                                {T(
                                                                    'host_lot_information',
                                                                )}
                                                                <span className="parent-first-column-value highlighted-lot">
                                                                    {
                                                                        childProductsItem.lot
                                                                    }
                                                                </span>
                                                            </div>
                                                            <span className="parent-second-column">
                                                                {T(
                                                                    'storeCondition',
                                                                )}
                                                                <span className="parent-second-column-value">
                                                                    {
                                                                        childProductsItem.storeCondition
                                                                    }
                                                                </span>
                                                            </span>
                                                        </div>
                                                        <div className="package-second-row">
                                                            <div className="parent-first-column">
                                                                {T(
                                                                    'shippment_details_shippment_quantity',
                                                                )}
                                                                <span className="parent-first-column-value">
                                                                    {
                                                                        childProductsItem.quantity
                                                                    }
                                                                </span>
                                                            </div>
                                                            <span className="parent-second-column">
                                                                {T(
                                                                    'fone_order_shipping_condition',
                                                                )}
                                                                <span className="parent-second-column-value">
                                                                    {
                                                                        childProductsItem.shippingCondition
                                                                    }
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </li>
                                                ),
                                            )
                                          : null}
                                  </ul>
                              </li>
                          ),
                      )
                    : null}
            </ul>
        );
    }
}

const mapStateToProps = (state) => {
    const {host, localData} = state;
    return {
        shipmentOrOrderDetails: host.shipmentOrOrderDetails,
        skuInventoryDetails: host.skuInventoryDetails,
        localData,
    };
};

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProxyDeliveryReceivePackageCard);
